import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import fireErrorAnalyticAndLogToSentry from '@atlassian/error-handling/fire-error-analytics';

import { getErrorType } from './get-error-type';

type AnalyticsAttributes = Record<string, any>;

type FireErrorAnalyticsPayload = {
	error: Error;
	id: string;
	viewType: string;
	analyticsViewType?: string;
	attributes?: AnalyticsAttributes;
	event?: UIAnalyticsEvent;
};

export const maskEmailIdsInMessage = (message: string): string =>
	message.replaceAll(/\w+@[\w.]+/gi, '***@***');

export const fireErrorAnalytics = ({
	error,
	id,
	viewType,
	analyticsViewType,
	attributes = {},
	event,
}: FireErrorAnalyticsPayload): void => {
	const errorType = getErrorType(error);
	// Name the event after the canonical viewType (when given) so overlay traffic
	// lands in the same bucket; the real viewType still goes into attributes below.
	const packageName = `${analyticsViewType ?? viewType}jiraUiModifications`;

	fireErrorAnalyticAndLogToSentry({
		event,
		meta: {
			id,
			packageName,
			teamName: 'unbox',
		},
		error,
		attributes: {
			errorType,
			errorMessage:
				typeof error.message === 'string' ? maskEmailIdsInMessage(error.message) : error.message,
			// Keep the real viewType in attributes so we know where the error came from.
			viewType,
			...attributes,
		},
	});
};
